import SessionTelemetry from '../store/schema/SessionTelemetry';
import { owaDate } from 'owa-datetime';
import { getGuid } from 'owa-guid';
import { getUserCulture } from 'owa-session-store';

export default function initializeTelemetryForSession(
    composeType: number,
    showSuggestions: boolean
): SessionTelemetry {
    const now = owaDate();
    return {
        sessionId: getGuid(),
        sessionStartTime: now,
        composeType: composeType,
        showSuggestions: showSuggestions,
        userCulture: getUserCulture(),
        requestsSentWithNoDelay: 0,
        requestsSentAfterDelay: 0,
        requestsAborted: 0,
        dsatReported: 0,
        satReported: 0,
    };
}
